import { IconSearch } from '@developerz/ui';
import { createSignal, type JSX } from 'solid-js';
import { t } from '../i18n';
import { Button, buttonClass } from './ui/Button';

// Repo KB tab → the search box (arc 101 slice 07 + the search route). Presenter:
// the container owns the APPLIED query, which is part of the query key, so
// applying re-ranks SERVER-side. Filtering the index page the client happens to
// hold would search 20 slugs and call it a wiki search.
//
// It applies ON SUBMIT, not per keystroke — `GET …/search` is a trigram rank
// over page bodies, so a half-typed word would spend a round trip answering a
// question nobody asked (`<ArtifactFilterBar/>`'s reasoning). The draft is local
// and controlled, so Clear empties the BOX as well as the applied query; a form
// reset would restore the applied text and tell the container nothing.

export function KbSearchBar(props: {
  readonly value: string;
  readonly onApply: (query: string) => void;
}): JSX.Element {
  const [draft, setDraft] = createSignal(props.value);

  const submit = (event: SubmitEvent): void => {
    event.preventDefault();
    props.onApply(draft().trim());
  };

  const clear = (): void => {
    setDraft('');
    props.onApply('');
  };

  return (
    <form class="filter-row" onSubmit={submit}>
      <div class="search-input">
        <IconSearch size="1rem" />
        <input
          type="search"
          class="input"
          name="q"
          placeholder={t('repo_kb.search_placeholder')}
          aria-label={t('repo_kb.search_aria')}
          value={draft()}
          onInput={(e) => setDraft(e.currentTarget.value)}
        />
      </div>
      <button type="submit" class={buttonClass({ variant: 'outline', size: 'sm' })}>
        {t('repo_kb.search')}
      </button>
      <Button variant="ghost" size="sm" onClick={clear}>
        {t('repo_kb.search_clear')}
      </Button>
    </form>
  );
}
